var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.275391,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.482 37.2257L49.682 71.7757L40.182 61.6257C38.432 59.9757 35.682 59.8757 33.682 61.2757C31.732 62.7257 31.182 65.2757 32.382 67.3257L43.632 85.6257C44.732 87.3257 46.632 88.3757 48.782 88.3757C50.832 88.3757 52.782 87.3257 53.882 85.6257C55.682 83.2757 90.032 42.3257 90.032 42.3257C94.532 37.7257 89.082 33.6757 85.482 37.1757V37.2257Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/paymentSuccess.5d30ec7da2b74775622b75074e9f95f9.svg";
export { ForwardRef as ReactComponent };